import React from "react";
import { Link } from "react-router-dom";

/*
 * Crisp, scalable wordmark that mirrors the Aesthetix MD logo.
 * Always visible on dark surfaces (unlike the tiny low-res image).
 */
export default function Logo({ size = "md", className = "" }) {
  const scale = {
    sm: { main: "text-lg", top: "text-[0.42rem]", bottom: "text-[0.4rem]" },
    md: { main: "text-2xl", top: "text-[0.5rem]", bottom: "text-[0.45rem]" },
    lg: { main: "text-3xl", top: "text-[0.55rem]", bottom: "text-[0.5rem]" },
  }[size];

  return (
    <Link to="/" className={`inline-flex flex-col items-center leading-none group ${className}`}>
      <span className={`eyebrow text-gold/70 ${scale.top} tracking-[0.34em] mb-1`}>
        Qualitas Care Clinic
      </span>
      <span className={`font-display font-medium text-cream ${scale.main} tracking-[0.12em]`}>
        A&#274;STHETIX <span className="text-gold">MD</span>
      </span>
      <span className={`eyebrow text-cream/45 ${scale.bottom} tracking-[0.3em] mt-1.5`}>
        Cosmetic&nbsp;&middot;&nbsp;Medical&nbsp;&middot;&nbsp;Wellness
      </span>
    </Link>
  );
}
